"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withThemeVariant = exports.default = exports.ThemeContext = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/styles");

var _responsiveFontSizes = _interopRequireDefault(require("@material-ui/core/styles/responsiveFontSizes"));

var _styles2 = require("@material-ui/core/styles");

var _cssVarsPonyfill = _interopRequireDefault(require("css-vars-ponyfill"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// This is a weird helper function, as JS behaves king of quirky with the require syntax when it is used in es modules but compiled to CommonJS
var interopRequireDefault = function interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj.default : obj;
};
/* Context */


var ThemeContext = /*#__PURE__*/_react.default.createContext({});

exports.ThemeContext = ThemeContext;

/**
 * Global theme variant provider
 *
 **/
var ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'pc' : _ref$variant,
      subvariant = _ref.subvariant,
      muiThemeOverride = _ref.muiThemeOverride;
  var generalStyles; //For compatibility with truck-jobs.com components

  if (variant === 'pc' || variant === 'bc' || variant === 'logistics-scheduler') {
    generalStyles = interopRequireDefault(require('./truck.module.scss'));
  } else {
    //For compatibility with Jobmatch.me components
    generalStyles = ['jmm', 'truck', 'care'].includes(variant) ? interopRequireDefault(require("./".concat(variant, ".module.scss"))) : ''; // interopRequireDefault(require('./jmm.module.scss')) // Fallback to truck styles to support oder variants used for truck pages
  }

  (0, _react.useEffect)(function () {
    (0, _cssVarsPonyfill.default)({
      variables: generalStyles,
      watch: true
    });
  }, [generalStyles]);

  var selectTheme = function selectTheme(variant) {
    return muiThemes[variant] || muiThemes.truck;
  }; // With fallback to truck styles


  var injectMuiThemeOverride = function injectMuiThemeOverride(theme) {
    return muiThemeOverride ? (0, _extends2.default)({}, theme, muiThemeOverride(generalStyles)) : theme;
  };

  var commonOverrides = {
    MuiPaper: {
      rounded: {
        borderRadius: '10px'
      },
      elevation1: {
        boxShadow: "-1px 3px 10px ".concat(generalStyles.shadowColor)
      }
    }
  };
  var muiThemes = {
    jmm: {
      palette: {
        primary: {
          main: generalStyles.primary
        },
        secondary: {
          main: generalStyles.secondary
        },
        // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        //contrastThreshold: 3,
        // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset: 0.2,
        common: {
          black: generalStyles.text
        },
        text: {
          primary: generalStyles.dark
        }
      },
      spacing: 2,
      typography: {
        fontFamily: generalStyles.fontFamilyBase,
        h1: {
          fontSize: '68px',
          marginBottom: '30px',
          fontWeight: 600,
          lineHeight: 1
        },
        h2: {
          fontSize: '48px',
          marginBottom: '30px',
          fontWeight: 600
        },
        h3: {
          fontSize: '48px',
          marginBottom: '30px',
          fontWeight: 600
        }
      },
      overrides: (0, _extends2.default)({}, commonOverrides, {
        MuiSlider: {
          thumb: {
            backgroundColor: generalStyles.dark,
            marginTop: '-9px!important',
            marginLeft: '-13px!important',
            height: '30px',
            width: '30px'
          },
          track: {
            backgroundColor: generalStyles.primary,
            borderRadius: '6px',
            height: '12px'
          },
          rail: {
            color: generalStyles.light,
            border: "1px solid ".concat(generalStyles.dark),
            borderRadius: '6px',
            height: '12px'
          }
        },
        MuiChip: {
          sizeSmall: {
            fontSize: generalStyles['fontSize-base-extra-small'],
            fontFamily: generalStyles.fontFamilyBaseBold
          }
        }
      })
    },
    // Truck Theme
    truck: {
      palette: {
        primary: {
          main: generalStyles.primary || '#052c48'
        },
        secondary: {
          main: generalStyles.secondary || '#20aee2',
          contrastText: generalStyles.light || '#fff'
        }
      },
      typography: {
        fontFamily: generalStyles.fontFamilyBase,
        useNextVariants: true
      },
      overrides: (0, _extends2.default)({}, commonOverrides, {
        MuiInput: {
          underline: {
            '&:before': {
              borderBottom: 'none'
            },
            '&:hover:not($disabled):not($error):not($focused):before': {
              borderBottom: 'none'
            },
            '&:after': {
              borderBottom: 'none'
            }
          },
          '&$focused': {
            borderBottom: 'none'
          }
        },
        MuiSlider: {
          thumb: {
            backgroundColor: generalStyles.primary,
            marginTop: '-9px!important',
            marginLeft: '-13px!important',
            height: '30px',
            width: '30px'
          },
          track: {
            backgroundColor: generalStyles.dark,
            borderRadius: '6px',
            height: '12px'
          },
          rail: {
            color: generalStyles.light,
            border: "2px solid ".concat(generalStyles.dark),
            borderRadius: '6px',
            height: '12px'
          }
        }
      })
    },
    // Care Theme
    care: {
      palette: {
        primary: {
          main: generalStyles.primary
        },
        secondary: {
          main: generalStyles.secondary
        },
        // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        // contrastThreshold: 3,
        // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset: 0.2,
        common: {
          black: generalStyles.text
        }
      },
      spacing: 2,
      typography: {
        fontFamily: generalStyles.fontFamilyBase,
        h1: {
          fontSize: '68px',
          marginBottom: '30px',
          fontWeight: 600,
          lineHeight: 1
        },
        h2: {
          fontSize: '48px',
          marginBottom: '30px',
          fontWeight: 600
        },
        h3: {
          fontSize: '38px',
          marginBottom: '30px',
          fontWeight: 600
        },
        h4: {
          fontSize: '28px',
          marginBottom: '30px',
          fontWeight: 600
        }
      },
      overrides: (0, _extends2.default)({}, commonOverrides, {
        MuiSlider: {
          thumb: {
            backgroundColor: generalStyles.dark,
            marginTop: '-9px!important',
            marginLeft: '-13px!important',
            height: '30px',
            width: '30px'
          },
          track: {
            backgroundColor: generalStyles.primary,
            borderRadius: '6px',
            height: '12px'
          },
          rail: {
            color: generalStyles.light,
            border: "1px solid ".concat(generalStyles.dark),
            borderRadius: '6px',
            height: '12px'
          }
        }
      })
    }
  };

  var _useState = (0, _react.useState)({
    variant: variant,
    subvariant: subvariant || '',
    muiTheme: (0, _responsiveFontSizes.default)((0, _styles2.createTheme)(injectMuiThemeOverride(selectTheme(variant))))
  }),
      _useState2 = (0, _slicedToArray2.default)(_useState, 1),
      state = _useState2[0];

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StylesProvider, {
    injectFirst: true,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.ThemeProvider, {
      theme: state.muiTheme,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ThemeContext.Provider, {
        value: state,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            fontFamily: generalStyles.fontFamilyBase
          },
          children: children
        })
      })
    })
  });
};
/**
 * The consumer component for the ThemeContext
 **/


var ThemeConsumer = ThemeContext.Consumer;
/**
 * HOC that provides the globalVariant Prop
 */

var withThemeVariant = function withThemeVariant(Component) {
  return function (props) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(ThemeConsumer, {
      children: // Components can be used without provider. HOC needs to be nullsave
      function children() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          variant: '',
          subvariant: '',
          muiTheme: {}
        };
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(Component, (0, _extends2.default)({
          globalThemeVariant: state.variant,
          globalThemeSubVariant: state.subvariant
        }, props));
      }
    });
  };
};

exports.withThemeVariant = withThemeVariant;
var _default = ThemeProvider;
exports.default = _default;